

import {
    LabelPosition,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IWorkFlowMaxSetupFieldsPanel {
}
export const WorkFlowMaxSetupFieldsPanel: FC<
    IWorkFlowMaxSetupFieldsPanel
> = ({ }) => {

    return (
        <>
            <RHookFormTextFieldWithLabel
                label="Account Key"
                id="account_key"
                testId={`account-key`}
                labelPosition={LabelPosition.Top}
            />
            <RHookFormTextFieldWithLabel
                label="Api Key"
                id="api_key"
                testId={`api-key`}
                labelPosition={LabelPosition.Top}
            />
        </>
    );
};
